/* @jsx h */
import { computed, defineComponent, h, ref, Transition } from "vue";
import { useRoute } from "vue-router";
import {
  navItemClass,
  navItemContentClass,
  navItemIconClass,
  navItemTextClass,
} from "./NavLink";

export type NavGroupProps = {
  title: string;
  icon: string;
  parentPath: string;
};
export const NavGroup = defineComponent<NavGroupProps>({
  name: "NavGroup",
  props: ["title", "icon", "parentPath"],
  setup(props, { slots }) {
    const route = useRoute();
    const isExpandedRef = ref(false);

    const isExpandedComputed = computed(() => {
      if (route.fullPath.startsWith(props.parentPath)) {
        return true;
      } else {
        return false;
      }
    });

    return () => {
      //      console.log("isExpanded", isExpanded.value);
      const isExpanded = isExpandedRef.value || isExpandedComputed.value;
      return (
        <div class={`nav-group`}>
          <button
            class={`${navItemClass(isExpandedComputed.value)} text-left`}
            onClick={() => {
              isExpandedRef.value = !isExpanded;
            }}
          >
            <div class={navItemContentClass}>
              <span class={navItemIconClass}>{props.icon}</span>
              <span class={navItemTextClass}>{props.title}</span>
            </div>
            <span
              class={`material-symbols-outlined ml-auto shrink-0 text-2xl leading-none transition-transform ${
                isExpanded ? "rotate-180" : ""
              }`}
            >
              expand_more
            </span>
          </button>

          <Transition name="expand">
            <div v-show={isExpanded} class="px-0 py-0 flex flex-col">
              {slots.default?.()}
            </div>
          </Transition>
        </div>
      );
    };
  },
});
